import active from './active';
import alerts from './alerts';
import audit from './audit';
import productName from './productName';
import sku from './sku';
import warehouseLocation from './warehouseLocation';
import warehouseName from './warehouseName';
import allocated from './allocated';
import available from './available';
import stock from './stock';
import productType from './productType';
import tracked from './tracked';
import reorderThreshold from './reorder-threshold';
import parentSKU from './parent-sku';
import actions from './actions';
import activeShippingLocations from '../../columns/activeShippingLocations';

export default {
  productName,
  sku,
  warehouseLocation,
  alerts,
  warehouseName,
  active,
  allocated,
  available,
  stock,
  productType,
  tracked,
  reorderThreshold,
  parentSKU,
  audit,
  actions,
  activeShippingLocations,
};
